import apiClient from './client';

export type TestType = 'copy' | 'design' | 'pricing' | 'flow' | 'trust' | 'seo';
export type TestPriority = 'high' | 'medium' | 'low';
export type TestStatus = 'new' | 'running' | 'completed' | 'dismissed';

export interface AbTestSuggestion {
  id: number;
  store_audit_run_id: number | null;
  test_type: TestType;
  test_type_label: string;
  priority: TestPriority;
  priority_label: string;
  status: TestStatus;
  status_label: string;
  is_active: boolean;
  page_or_element: string;
  hypothesis: string;
  control_description: string;
  variant_description: string;
  expected_impact: string;
  estimated_lift_pct: number | null;
  created_at: string;
  updated_at: string;
}

export interface AbTestBatchResult {
  batch_id: number;
  suggestion_count: number;
  ai_model: string;
  cost_usd: number;
}

export interface PaginatedAbTests {
  data: AbTestSuggestion[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

const BASE = '/ab-tests';

export const abTestsApi = {
  list: (params?: { status?: TestStatus; test_type?: TestType; page?: number }) =>
    apiClient
      .get<{ success: boolean; data: AbTestSuggestion[]; meta: PaginatedAbTests['meta'] }>(BASE, { params })
      .then((r) => r.data),

  generate: (auditRunId?: number) =>
    apiClient
      .post<{ success: boolean; data: AbTestBatchResult }>(`${BASE}/generate`, { audit_run_id: auditRunId })
      .then((r) => r.data.data),

  find: (id: number) =>
    apiClient.get<{ success: boolean; data: AbTestSuggestion }>(`${BASE}/${id}`).then((r) => r.data.data),

  updateStatus: (id: number, status: TestStatus) =>
    apiClient
      .patch<{ success: boolean; data: AbTestSuggestion }>(`${BASE}/${id}/status`, { status })
      .then((r) => r.data.data),

  destroy: (id: number) => apiClient.delete(`${BASE}/${id}`),
};
